import { makeAutoObservable } from "mobx";
import api from "../../api";
import { IJob } from "../../api/jobs/JobsApi";
import Job from "./Job";

class JobsStore {
  jobs: Job[] = [];
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  async getJobs(applicationId: string) {
    this.isLoading = true;
    try {
      const jobs: IJob[] = await api.jobs.retrieveJobs(applicationId);
      const mappedJobs = jobs.map(Job.convertFrom);

      this.jobs = mappedJobs;
    } catch (e) {
      console.error(e);
      this.jobs = [];
    } finally {
      this.isLoading = false;
    }
  }
}

export default JobsStore;
